// extracted by mini-css-extract-plugin
module.exports = {"primary":"styles_primary__yg4hB","secondary":"styles_secondary__YfLd0"};